import React from "react";
import {BarcodeScanner as DynamsoftScanner} from "dynamsoft-barcode-reader-bundle";
import * as Dynamsoft from "dynamsoft-barcode-reader-bundle";
import request from "../../../util/SuperagentUtils";
import "./style/BarcodeScanner.css";

// This class should contain no internal React state and instead should rely on props
const BarcodeScanner = ({readScannedResults}) => {
  const elRef = React.useRef(null);
  const scannerRef = React.useRef(null);
  const destroyedRef = React.useRef(false);

  React.useEffect(() => {
    const initScanner = async () => {
      try {
        // Only load product keys and resource path on first time initialization
        if (!Dynamsoft.CoreModule.isModuleLoaded('license')) {
          const response = await request
            .get("/api/ocr-keys")
            .then((json) => {
              const result = JSON.parse(json.text);
              return result?.dynamsoftKey;
            });

          if (!response) {
            throw new Error("Failed to fetch Dynamsoft license key.");
          }
          await Dynamsoft.CoreModule.loadWasm(["dbr"]);
          await Dynamsoft.LicenseManager.initLicense(response);
        }

        scannerRef.current = scannerRef.current || await DynamsoftScanner.createInstance();

        if (destroyedRef.current) {
          scannerRef.current.destroy();
          return;
        }

        await scannerRef.current.setUIElement(elRef.current);

        //Set scanner to read PDF417
        const runtimeSettings = await scannerRef.current.getRuntimeSettings();
        runtimeSettings.barcodeFormatIds = Dynamsoft.EnumBarcodeFormat.BF_PDF417;
        await scannerRef.current.updateRuntimeSettings(runtimeSettings);

        scannerRef.current.onFrameRead = results => {
          if (results.length) {
            scannerRef.current.pauseScan();
            readScannedResults(results[0].barcodeText);
          }
        };

        scannerRef.current.onUniqueRead = (txt) => {
          scannerRef.current.pauseScan();
          readScannedResults(txt);
        };

        await scannerRef.current.open();
        await scannerRef.current.setResolution(1280, 720);
      } catch (ex) {
        console.log(ex.message);
        console.error(ex);
      }
    };

    initScanner();

    return () => {
      destroyedRef.current = true;
      if (scannerRef.current) {
        scannerRef.current.destroy();
      }
    };
  }, [readScannedResults]);

  return (
    <div ref={elRef} className="component-barcode-scanner">
      <svg className="dbrScanner-bg-loading" viewBox="0 0 1792 1792"/>
      <svg className="dbrScanner-bg-camera" viewBox="0 0 2048 1792">
        <path
          d="M1024 672q119 0 203.5 84.5t84.5 203.5-84.5 203.5-203.5 84.5-203.5-84.5-84.5-203.5 84.5-203.5 203.5-84.5zm704-416q106 0 181 75t75 181v896q0 106-75 181t-181 75h-1408q-106 0-181-75t-75-181v-896q0-106 75-181t181-75h224l51-136q19-49 69.5-84.5t103.5-35.5h512q53 0 103.5 35.5t69.5 84.5l51 136h224zm-704 1152q185 0 316.5-131.5t131.5-316.5-131.5-316.5-316.5-131.5-316.5 131.5-131.5 316.5 131.5 316.5 316.5 131.5z"/>
      </svg>
      <video className="dbrScanner-video" playsInline={true}/>
      <canvas className="dbrScanner-cvs-drawarea"/>
      <div className="dbrScanner-cvs-scanarea">
        <div className="dbrScanner-scanlight"/>
      </div>
    </div>
  );
};

export default BarcodeScanner;
